export const initSearchForm = () => {
  // .global-search-active
  // add document focus event listener
  $("body").on("focus", ".global-search-form input", onSearchFormFocus)
  $("body").on("focusout", ".global-search-form input", onSearchFormFocusOut)
  
}

const onSearchFormFocus = (e) => {
  document.documentElement.classList.add('global-search-active');
}
const onSearchFormFocusOut = (e) => {
  document.documentElement.classList.remove('global-search-active');  
}